import request from "./request";

//下拉查询
export const getTotalReportParams = () => request("/totalReport/getTotalReportParams", null, "GET");
//查询数据
export const getTotalReport = (data) => request("/totalReport/getTotalReport", data, "POST");

// 获取投放总表数据
export const getTotalTableList = (data) => request("/totalReport/totalPopuReport", data, "POST_JSON");